export const getErrorMessage = (error: Error | any, defaultMessage: string) => {
  const message =
    error.response?.data?.message ??
    error?.response?.data?.error ??
    error.message ??
    defaultMessage;

  // Handle timeout/network errors with a user-friendly message
  if (
    message === "Network Error" ||
    error.code === "ECONNABORTED" ||
    error.code === "ERR_NETWORK" ||
    error.response?.status === 504 ||
    error.response?.status === 502 ||
    error.response?.status === 408
  ) {
    return "Try Again";
  }

  return message;
};
